import { useParams } from 'react-router-dom';
import { VscSettingsGear } from 'react-icons/vsc';
import { useTranslation } from 'react-i18next';

import { Breadcrumbs } from '../../../components/Breadcrumbs';
import Button from '../../../components/Button/Button';
import Loading from '../../../components/Loading';
import { FormField } from '../../../components/FormField';
import { useGetStore } from '../../../network';

export const StorePage = () => {
    const { t } = useTranslation();

    const { slug } = useParams();

    const pages = [{ name: t('Stores'), path: '/chain/stores' }];

    const { data: storeInfo = {}, isLoading } = useGetStore({ slug });

    const breadcrumbs = [...pages, { name: storeInfo.name, path: `/chain/stores/${slug}` }];

    return (
        <div>
            <Breadcrumbs pages={storeInfo.name ? breadcrumbs : []} />
            <div className="max-w-screen-lg flex flex-col md:flex-row md:justify-between items-start md:items-center">
                <div className="flex gap-2">
                    <Button
                        type="link"
                        to={`/chain/stores/${slug}/edit`}
                        isUpperCase={false}
                        className="whitespace-nowrap h-9 inline-flex items-center rounded-lg border border-transparent bg-purple-500 px-6 py-1.5 text-sm font-bold text-white shadow-sm hover:bg-purple-600 focus:outline-none"
                    >
                        <VscSettingsGear className="mr-3" size={20} />
                        {t('Settings')}
                    </Button>

                    <Button
                        type="link"
                        to={`/chain/stores/${slug}/inventory`}
                        isUpperCase={false}
                        className="whitespace-nowrap h-9 inline-flex items-center rounded-lg border border-transparent px-6 py-1.5 text-sm font-bold text-white shadow-sm focus:outline-none"
                    >
                        {t('Inventory')}
                    </Button>
                </div>

                <div className="mt-4 md:mt-0 md:ml-auto flex flex-col-reverse sm:flex-row sm:justify-between gap-4">
                    <FormField disabled popoverText="On development stage" popoverStyle={{ left: -5, minWidth: 220 }}>
                        <Button color="bg-danger" disabled={isLoading}>
                            {t('Archive')}
                        </Button>
                    </FormField>
                </div>
            </div>
            <Loading loading={isLoading}>
                <div className="mt-4 p-6 max-w-screen-lg bg-white rounded-xl shadow-lg flex flex-col gap-8">
                    <div className="grid grid-cols-3 text-base">
                        <div className="flex flex-col gap-6 col-span-1">
                            <span className="opacity-50">Name</span>
                            <span className="opacity-50">Address</span>
                        </div>
                        <div className="flex flex-col gap-5 col-span-2">
                            <span>{storeInfo.name}</span>
                            <span>{storeInfo.address}</span>
                        </div>
                    </div>
                </div>
            </Loading>
        </div>
    );
};
